import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Phase 15.4 - Premium Floating Navigation
 * With glassmorphism, smooth animations, and active state transitions
 */
function FamilyNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      path: '/family/dashboard',
      icon: '🏠',
      label: 'Home'
    },
    {
      path: '/family/seniors',
      icon: '👨‍👩‍👧',
      label: 'Familie'
    },
    {
      path: '/family/modules',
      icon: '🧩',
      label: 'Module'
    },
    {
      path: '/family/activity',
      icon: '📊',
      label: 'Aktivität'
    },
    {
      path: '/family/notifications',
      icon: '🔔',
      label: 'Meldungen'
    }
  ];

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 pb-safe animate-slide-up">
      {/* Floating Nav Container - Hayat Dark Theme */}
      <div className="max-w-2xl mx-auto px-4 pb-4">
        <div className="bg-neutral-900/90 backdrop-blur-2xl rounded-3xl shadow-2xl border border-neutral-600/40">
          <div className="flex items-center justify-around py-3 px-2">
            {navItems.map(item => {
              const active = isActive(item.path);
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={`
                    flex flex-col items-center justify-center gap-1 px-4 py-2 rounded-2xl
                    transition-all duration-300 min-w-[70px] min-h-[60px]
                    active:scale-95 relative
                    ${active 
                      ? 'bg-gradient-to-br from-[#5B4B8A] to-[#4a3d72] text-white scale-105 shadow-lg' 
                      : 'text-neutral-500 hover:bg-neutral-800/50 hover:text-[#6DCEE8] hover:scale-105'
                    }
                  `}
                >
                  {/* Active indicator dot */}
                  {active && (
                    <div className="absolute -top-1 w-1.5 h-1.5 rounded-full bg-[#6DCEE8] animate-pulse"></div>
                  )}
                  
                  <span className={`text-2xl transition-transform duration-300 ${active ? 'scale-110' : ''}`}>
                    {item.icon}
                  </span>
                  <span className={`text-xs font-medium transition-all duration-300 ${active ? 'font-bold' : ''}`}>
                    {item.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default FamilyNavigation;
